export default "__VITE_ASSET__C49nmIUw__"